export default {
  setServices: (state, value) => {
    state.services = value
  },

  setServicePageData: (state, value) => {
    state.servicePageData = {
      ...state.servicePageData,
      ...value,
    }
  },

  setCarePlan: (state, carePlanId) => {
    state.servicePageData = {
      ...state.servicePageData,
      selectedCarePlan: carePlanId,
    }
  },
}
